var PropTypes = require('prop-types');
var React = require('react');

var Translator = require('../../cornucopia/core/translator');
var classNames = require('classnames');

class UserTypeSelect extends React.Component {
  static propTypes = {
    userType: PropTypes.string,
    onUserTypeChange: PropTypes.func
  };

  _handleOnChange = (event) => {
    var userTypeValue = event.target.value;
    this.props.onUserTypeChange(userTypeValue);
  };

  _getTitleUser = () => {
    var content = null;
    var t1User;
    var t2User;

    switch (this.props.userType) {
      case 'tenant':
        t1User = Translator.trans('contact_us.user_type.tenant.t1user');
        t2User = Translator.trans('contact_us.user_type.tenant.t2user');
        break;
      case 'landlord':
        t1User = Translator.trans('contact_us.user_type.landlord.t1user');
        t2User = Translator.trans('contact_us.user_type.landlord.t2user');
        break;
      case 'partnerships':
        t1User = Translator.trans('contact_us.user_type.partnerships.t1user');
        t2User = Translator.trans('contact_us.user_type.partnerships.t2user');
        break;
      case 'enquiries':
        t1User = Translator.trans('contact_us.user_type.enquiries.t1user');
        t2User = Translator.trans('contact_us.user_type.enquiries.t2user');
        break;
      default:
        t1User = '';
        t2User = '';
    }

    if (t1User) {
      content = (
        <h3 className="contact-us__title">
          {t1User}
          <span>{t2User}</span>
        </h3>
      );
    }

    return content;
  };

  _renderTitleUser = () => {
    var content = null;
    var titleUser = this._getTitleUser();
    var classes = classNames('contact-us__title-box', {
      icon__tenant: this.props.userType === 'tenant',
      icon__landlord: this.props.userType === 'landlord',
      icon__partnerships: this.props.userType === 'partnerships',
      icon__enquiries: this.props.userType === 'enquiries'
    });

    if (titleUser) {
      content = <div className={classes}>{titleUser}</div>;
    }

    return content;
  };

  render() {
    return (
      <div>
        <fieldset>
          <legend>
            {Translator.trans('contact_us.user_type.option.legend')}
          </legend>
          <div className="contact-us__select">
            <select
              value={this.props.userType}
              onChange={this._handleOnChange}
              className="contact-us__user-type"
            >
              <option value="" disabled>
                {Translator.trans('contact_us.user_type.option.default')}
              </option>
              <option value="tenant">
                {Translator.trans('contact_us.user_type.option.tenant')}
              </option>
              <option value="landlord">
                {Translator.trans('contact_us.user_type.option.landlord')}
              </option>
              <option value="partnerships">
                {Translator.trans('contact_us.user_type.option.partnerships')}
              </option>
              <option value="enquiries">
                {Translator.trans('contact_us.user_type.option.enquiries')}
              </option>
            </select>
          </div>
        </fieldset>

        {this._renderTitleUser()}
      </div>
    );
  }
}

module.exports = UserTypeSelect;